export const RESET = 'EXABORGANIZATIONLEAD_UPDATE_RESET'
export const SET_ERROR = 'EXABORGANIZATIONLEAD_UPDATE_SET_ERROR'
export const SET_RETRIEVED = 'EXABORGANIZATIONLEAD_UPDATE_SET_RETRIEVED'
export const SET_UPDATED = 'EXABORGANIZATIONLEAD_UPDATE_SET_UPDATED'
export const SET_VIOLATIONS = 'EXABORGANIZATIONLEAD_UPDATE_SET_VIOLATIONS'
export const TOGGLE_LOADING = 'EXABORGANIZATIONLEAD_UPDATE_TOGGLE_LOADING'
export const UPDATE_RETRIEVED = 'EXABORGANIZATIONLEAD_UPDATE_UPDATE_RETRIEVED'
